// modules
import { handleActions } from 'redux-actions'

// utils
import {
  setSummaryList,
  setDetailedList,
  resetCaseManagerCensus
} from 'src/store/modules/reports/caseManagerCensus'

const initialState = {
  summaryList: [],
  detailedList: []
}

export default handleActions(
  {
    [setSummaryList](state, { payload: summaryList }) {
      return {
        ...state,
        summaryList
      }
    },

    [setDetailedList](state, { payload: detailedList }) {
      return {
        ...state,
        detailedList
      }
    },

    [resetCaseManagerCensus]() {
      return initialState
    }
  },
  initialState
)
